import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finance-portal',
  templateUrl: './finance-portal.component.html',
  styleUrls: ['./finance-portal.component.sass']
})
export class FinancePortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
